module.exports = __webpack_public_path__ + "data/skeeballPlay.f70a7ad2faeb6af1051203af39fe064d.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=data/[name].[hash].json!./app/assets/image/NC/skeeballPlay.json
// module id = 352
// module chunks = 0